import React from 'react';
import { useTheme, THEME_MODE } from '../context/ThemeContext';
import { useTranslation } from 'react-i18next';

const ThemeToggle = () => {
  const { themeMode, isDarkMode, changeThemeMode, THEME_MODE } = useTheme();
  const { t } = useTranslation();

  return (
    <div className="dropdown">
      <button 
        className="btn btn-sm btn-outline-secondary dropdown-toggle" 
        type="button" 
        id="themeDropdown" 
        data-bs-toggle="dropdown" 
        aria-expanded="false"
      >
        <i className={`fas fa-${
          themeMode === THEME_MODE.SYSTEM 
            ? 'desktop' 
            : (isDarkMode ? 'moon' : 'sun')
        } me-1`}></i>
        <span className="d-none d-md-inline">
          {t(`theme.${themeMode}`)}
        </span>
      </button>
      <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="themeDropdown">
        <li>
          <button 
            className={`dropdown-item ${themeMode === THEME_MODE.SYSTEM ? 'active' : ''}`} 
            onClick={() => changeThemeMode(THEME_MODE.SYSTEM)}
          >
            <i className="fas fa-desktop me-2"></i>
            {t('theme.system')}
          </button>
        </li>
        <li>
          <button 
            className={`dropdown-item ${themeMode === THEME_MODE.LIGHT ? 'active' : ''}`} 
            onClick={() => changeThemeMode(THEME_MODE.LIGHT)}
          >
            <i className="fas fa-sun me-2"></i>
            {t('theme.light')}
          </button>
        </li>
        <li>
          <button 
            className={`dropdown-item ${themeMode === THEME_MODE.DARK ? 'active' : ''}`} 
            onClick={() => changeThemeMode(THEME_MODE.DARK)}
          >
            <i className="fas fa-moon me-2"></i>
            {t('theme.dark')}
          </button>
        </li>
      </ul>
    </div>
  );
};

export default ThemeToggle;
